import { useMemo } from 'react'

import {
  type DictionaryDto,
  type DictionaryItemValueDto,
} from '@redteclab/api/clients/composition-service-marketplace'

import { useMarketplacePartnerRegisterApiSwrGetDictionaries } from '../api/swr/useMarketplacePartnerRegisterPageFormApiGetDictionaries'

export type MarketplacePartnerRegisterPageDictionaryOption = {
  key: string
  label: string
}

export const useMarketplacePartnerRegisterPageGetDictionaryOptionsByName = (
  name: string,
  language: string,
): MarketplacePartnerRegisterPageDictionaryOption[] | undefined => {
  const dictionaries = useMarketplacePartnerRegisterApiSwrGetDictionaries().data

  return useMemo(() => {
    if (!dictionaries) {
      return undefined
    }

    const dictionary: DictionaryDto | undefined = dictionaries.find(
      (dict) => dict.name === name,
    )

    if (!dictionary) {
      return undefined
    }

    const options = dictionary.items
      .map((item: DictionaryItemValueDto) => {
        const valueForLanguage = item.value.find(
          (val) => val.language === language,
        )

        return valueForLanguage
          ? {
              key: item.key,
              label: valueForLanguage.label,
            }
          : undefined
      })
      .filter(
        (option): option is MarketplacePartnerRegisterPageDictionaryOption =>
          option !== undefined,
      )

    if (options.length === 0) {
      return undefined
    }

    return options
  }, [dictionaries, language, name])
}
